import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { FeatureFlagNavLink } from './FeatureFlagNavLink';
import { FeatureFlags } from '../../../../shared/featureFlagConfig/configFromAdmin';
import { getInquiryIdSelector } from '../../../../store/inquiryDetails/selectors';
import { useTranslations } from '../../../../utils/hooks/useTranslations';

export type NavItem = {
  path: (inquiryId: string) => string;
  labelKey: string;
  featureFlag?: FeatureFlags;
  testId?: string;
};

export const SubNavigationItem = ({ path, labelKey, featureFlag, testId }: NavItem) => {
  const inquiryId = useSelector(getInquiryIdSelector) as string;
  const t = useTranslations();

  if (featureFlag) {
    return (
      <FeatureFlagNavLink testId={testId} to={path(inquiryId)} featureFlag={featureFlag}>
        {t(labelKey)}
      </FeatureFlagNavLink>
    );
  } else {
    return (
      <li>
        <NavLink data-testid={testId} activeClassName="active" to={path(inquiryId)}>
          {t(labelKey)}
        </NavLink>
      </li>
    );
  }
};
